<template lang="pug">
  .header-logo
    h1.header-logo__heading(v-if="h1")
      a.header-logo__image(href="/")
        img(:src="image", :srcset="imageSource", :alt="alt")
        span.u-hidden {{ alt }}
    div(v-else)
      a.header-logo__image(href="/")
        img(:src="image", :srcset="imageSource", :alt="alt")
</template>

<script>
  export default {
    name: 'HeaderLogo',
    props: {
      image: String,
      largeImage: String,
      alt: String,
      h1: Boolean,
    },
    computed: {
      imageSource() {
        return `${this.image} 1x, ${this.largeImage} 2x`;
      },
    },
  };
</script>
